export const CALL_CLASSIFICATION_LABELS = {
  order_new: 'Новый заказ',
  order_confirm_outbound: 'Подтверждение заказа',
  order_change: 'Изменение заказа',
  delivery_issue: 'Жалоба',
  consultation: 'Консультация',
  callback_missed: 'Пропущенный дозвон',
  wrong_number: 'Ошибочный номер'
};

export const CALL_CLASSIFICATION_COLORS = {
  order_new: '#2563eb',
  order_confirm_outbound: '#0ea5e9',
  order_change: '#a855f7',
  delivery_issue: '#f97316',
  consultation: '#22c55e',
  callback_missed: '#eab308',
  wrong_number: '#14b8a6',
  __unknown: '#94a3b8'
};

export const formatClassificationType = (value) => {
  if (!value) return 'Без темы';
  const key = String(value).trim().toLowerCase();
  if (!key) return 'Без темы';
  if (CALL_CLASSIFICATION_LABELS[key]) return CALL_CLASSIFICATION_LABELS[key];
  return key
    .split('_')
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(' ');
};
